export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9748.055f9cd6.jpg";